<div class="modal-signup modal-content">
  <div>
    <div class="card col-xl-12 col-lg-12 col-md-12 col-sm-12  my-profile-form document">


      <div class="card-header wh-header padding-bottom-0px">

        Profile Info

        <button type="button" class="close" data-dismiss="modal"
                (click)="activeModal.dismiss('Cross click')"
                aria-label="Close">
          <span aria-hidden="true">&times;</span>
        </button>
      </div>

      <div class="modal-body padding-top-0px">



        <ul class="nav nav-tabs nav-tab-service2 margin-top-13px" id="tabContent">
          <li class="active margin-right-15px"><a class="nav-itemerp active" href="#details" data-toggle="tab">1.General</a></li>
          <li class="margin-right-15px"><a class="nav-itemerp" href="#Education" data-toggle="tab">2.Education</a></li>
          <li class="margin-right-15px"><a class="nav-itemerp" href="#Registration" data-toggle="tab">3.Registration</a></li>
          <li class="margin-right-15px"><a class="nav-itemerp" href="#Overseas" data-toggle="tab" >4.Overseas</a></li>
          <li class="margin-right-15px"><a class="nav-itemerp" href="#Referral" data-toggle="tab">5.Referral</a></li>
          <li class="margin-right-15px"><a class="nav-itemerp" href="#address" data-toggle="tab">6.Address</a></li>
          <li class="margin-right-15px"><a class="nav-itemerp" href="#contact" data-toggle="tab">7.Contact</a></li>
          <li><a class="nav-itemerp" href="#spouse" data-toggle="tab" hidden>8.Partner</a></li>
        </ul>

        <div class="tab-content">
          <div class="tab-pane active" id="details">
            <div class="card">
              <div class="card-body margin-left-zero padding-left-0px padding-right-0px padding-bottom-0px">
                <div class="row">
                  <div class="col-md-12 padding-l-0px">
                    <form class="form" novalidate="" (ngSubmit)="General()" #f="ngForm">
                      <div class="card col-xl-12 col-lg-12 col-md-12 col-sm-12 my-profile-form padding-lr-0px">

                        <div class="card-body card-body-general">
                          <div class="row">


                            <div class="form-group offset-md-1 col-md-3 col-xs-12">

                              <div class="image-upload-box font-size-16px">

                                <img class="img-circle-65px" [src]='' height="50" width="50" alt="">
                                <!--<button (click)="OpenCamera()"><i class="fa fa-camera"></i></button>-->
                                <!--<imageinfo [ActorCode]='CurrentActorPersonalDetailInfoRequest.ActorCode'
                                [CanEdit]="1" [CanShow]="1"
                                (actorImageInfoChange)="onactorImageInfoChange($event)"
                                *ngIf="CurrentActorPersonalDetailInfoRequest.ActorCode >0"></imageinfo>-->
                              </div>
                              <!--<imageinfo [ActorCode]='CurrentActorPersonalDetailInfoRequest.ActorCode'
                              [CanEdit]="1" [CanShow]="1"
                              (actorImageInfoChange)="onactorImageInfoChange($event)"
                              *ngIf="CurrentActorPersonalDetailInfoRequest.ActorCode >0"
                              ></imageinfo>-->


                              <div class="user-status">

                                <!--<h3 class="bold-text user-title">{{CurrentActorPersonalDetailInfoRequest.DisplayName}}</h3>
                                <span class="i-text">{{CurrentActorPersonalDetailInfoRequest.ProfileTitle}}</span>-->
                                <!--<span>Designation <span>|</span> Hours <span>|</span> Shift <span>|</span> $0</span>-->
                              </div>
                            </div>
                          </div>
                          <div class="row">
                            <div class="col-md-6">
                              <div class="row">
                                <div class="form-group col-md-12 col-xs-12 margin-bottom-5px">
                                  <div class="row">
                                    <div class="col-md-5 text-align-right">
                                      <label for="firstName"><span>*</span> Name Prefix</label>
                                    </div>
                                    <div class="col-md-7">
                                      <CodeTypeValue CodeType="NPRE"
                                                     id="CurrentSavePatientInfoRequest.Prefix" PassType="Long"
                                                     [(ngModel)]="CurrentSavePatientInfoRequest.Prefix" SelectedValue="{{CurrentSavePatientInfoRequest.Prefix}}"
                                                     name="CurrentSavePatientInfoRequest.Prefix" required #Prefix="ngModel">
                                      </CodeTypeValue>
                                      <!--<input type="text" class="form-control" placeholder="Prefix" id="CurrentSavePatientInfoRequest.Salutation"
                                             [(ngModel)]="CurrentSavePatientInfoRequest.Salutation"
                                             name="CurrentSavePatientInfoRequest.Salutation" pattern="^[\sa-zA-Z0-9,._\-?]*$"
                                             maxlength="20" minlength="1" #Salutation="ngModel" required>
                                      <small class="form-text text-danger"
                                             *ngIf="(!Salutation.valid && (Salutation.dirty || Salutation.touched) && Salutation.errors.required )">(Field cannot be left blank)</small>
                                      <small class="form-text text-danger"
                                             *ngIf="(!Salutation.valid && Salutation.errors.pattern)">(special characters are not allowed)</small>-->

                                    </div>


                                  </div>

                                </div>
                              </div>

                              <div class="row">
                                <div class="form-group col-md-12 col-xs-12 margin-bottom-5px">
                                  <div class="row">
                                    <div class="col-md-5 text-align-right">
                                      <label for="firstName"><span>*</span> Name </label>
                                    </div>
                                    <div class="col-md-7">

                                      <input type="text" class="form-control" placeholder="First Name"
                                             id="CurrentSavePatientInfoRequest.DisplayName"
                                             [(ngModel)]="CurrentSavePatientInfoRequest.DisplayName"
                                             name="CurrentSavePatientInfoRequest.DisplayName" pattern="^[\sa-zA-Z0-9,._\-?]*$"
                                             maxlength="30" minlength="1" #Name="ngModel" required>
                                      <small class="form-text text-danger"
                                             *ngIf="(!Name.valid && (Name.dirty || Name.touched) && Name.errors.required )">(Field cannot be left blank)</small>
                                      <small class="form-text text-danger"
                                             *ngIf="(!Name.valid && Name.errors.pattern)">(special characters are not allowed)</small>

                                    </div>

                                  </div>

                                </div>
                              </div>

                              <div class="row">
                                <div class="form-group col-md-12 col-xs-12 margin-bottom-5px">
                                  <div class="row">
                                    <div class="col-md-5 text-align-right">
                                      <label for="birthDate"><span>*</span> Date of Birth  </label>
                                    </div>
                                    <div class="col-md-7">
                                      <div class="date-form">
                                        <input class="form-control" placeholder=" Date" [minDate]="minDate" [maxDate]="maxDate"
                                               name="dpp" [(ngModel)]="DOB" ngbDatepicker  #dp="ngbDatepicker" #Birthp="ngModel" required>
                                        <!--<small class="form-text text-danger"
                                        *ngIf="(!DateOfBirth.valid && (DateOfBirth.dirty || DateOfBirth.touched) && DateOfBirth.errors.required)">(Field cannot be left blank)</small>-->
                                        <a (click)="dp.toggle()" class="nav-link-hand">
                                          <span class="date-icon"><i class="far fa-calendar-alt"></i></span>

                                        </a>
                                      </div>
                                    </div>


                                  </div>
                                </div>

                              </div>
                              <div class="row" hidden>
                                <div class="form-group col-md-12 col-xs-12 margin-bottom-5px">
                                  <div class="row">
                                    <div class="col-md-5 text-align-right">
                                      <label for="diaplayName"> Age   </label>
                                    </div>
                                    <div class="col-md-7">
                                      <input type="number" class="form-control" minlength="2" placeholder="Age" pattern="^[\sa-zA-Z0-9,._\-?]*$"
                                             id="CurrentSavePatientInfoRequest.Age"
                                             [(ngModel)]="CurrentSavePatientInfoRequest.Age"
                                             name="CurrentSavePatientInfoRequest.Age"
                                             #DisplayName="ngModel">
                                      <!--id="CurrentSavePatientInfoRequest.DisplayName"
                                        [(ngModel)]="CurrentActorPersonalDetailInfoRequest.DisplayName"
                                       name="CurrentActorPersonalDetailInfoRequest.DisplayName"
                                      required maxlength="40"  #Age="ngModel" >-->
                                      <!--<small class="form-text text-danger"
                                             *ngIf="(!DisplayName.valid && (DisplayName.dirty || DisplayName.touched) && DisplayName.errors.required)">(Field cannot be left blank)</small>
                                      <small class="form-text text-danger"
                                             *ngIf="(!DisplayName.valid && DisplayName.errors.pattern)">(special characters are not allowed)</small>-->
                                    </div>
                                  </div>


                                </div>
                              </div>
                              <div class="row">
                                <div class="form-group col-md-12 col-xs-12 margin-bottom-5px">
                                  <div class="row">
                                    <div class="col-md-5 text-align-right">
                                      <label for="diaplayName"><span>*</span> Sex</label>
                                    </div>

                                    <div class="col-md-7">
                                      <CodeTypeValue CodeType="Sex"
                                                     id="CurrentSavePatientInfoRequest.Gender" PassType="Long"
                                                     [(ngModel)]="CurrentSavePatientInfoRequest.Gender" SelectedValue="{{CurrentSavePatientInfoRequest.Gender}}"
                                                     name="CurrentSavePatientInfoRequest.Gender" required #Sex="ngModel">
                                      </CodeTypeValue>

                                    </div>
                                  </div>


                                </div>

                              </div>

                              <div class="row">
                                <div class="form-group col-md-12 col-xs-12 margin-bottom-5px">

                                  <div class="row">
                                    <div class="col-md-5 text-align-right">
                                      <label for="diaplayName">Occupation</label>
                                    </div>

                                    <div class="col-md-7">
                                      <input type="text" class="form-control" placeholder="Occupation"
                                             id="CurrentSavePatientInfoRequest.Occupation"
                                             [(ngModel)]="CurrentSavePatientInfoRequest.Occupation"
                                             name="CurrentSavePatientInfoRequest.Occupation" pattern="^[\sa-zA-Z0-9,._\-?]*$"
                                             maxlength="30" minlength="1">

                                    </div>
                                  </div>


                                </div>
                              </div>
                              <div class="row">
                                <div class="form-group col-md-12 col-xs-12 margin-bottom-5px">

                                  <div class="row">
                                    <div class="col-md-5 text-align-right">
                                      <label for="diaplayName">Organisation</label>
                                    </div>

                                    <div class="col-md-7">
                                      <input type="text" class="form-control" minlength="2" placeholder="Organisation"
                                             id="CurrentSavePatientInfoRequest.Institution"
                                             [(ngModel)]="CurrentSavePatientInfoRequest.Institution"
                                             name="CurrentSavePatientInfoRequest.Institution" pattern="^[\sa-zA-Z0-9,._\-?]*$"
                                             maxlength="30">


                                    </div>
                                  </div>


                                </div>
                              </div>
                              <div class="row">
                                <div class="form-group col-md-12 col-xs-12 margin-bottom-5px">

                                  <div class="row">
                                    <div class="col-md-5 text-align-right">
                                      <label for="diaplayName">Religion</label>
                                    </div>

                                    <div class="col-md-7">
                                      <CodeTypeValue CodeType="RELGN"
                                                     id="CurrentSavePatientInfoRequest.Religion" PassType="Long"
                                                     [(ngModel)]="CurrentSavePatientInfoRequest.Religion" SelectedValue="{{CurrentSavePatientInfoRequest.Religion}}"
                                                     name="CurrentSavePatientInfoRequest.Religion">
                                      </CodeTypeValue>
                                    </div>
                                  </div>


                                </div>
                              </div>


                            </div>

                            <div class="col-md-6">
                              <div class="row">
                                <div class="form-group col-md-12 col-xs-12 margin-bottom-5px">

                                  <div class="row">
                                    <div class="col-md-5 text-align-right">
                                      <label for="diaplayName">Blood Group</label>
                                    </div>

                                    <div class="col-md-7">
                                      <CodeTypeValue CodeType="BGRP"
                                                     id="CurrentSavePatientInfoRequest.BloodGroup"
                                                     [(ngModel)]="CurrentSavePatientInfoRequest.BloodGroup" SelectedValue="{{CurrentSavePatientInfoRequest.BloodGroup}}"
                                                     name="CurrentSavePatientInfoRequest.BloodGroup">
                                      </CodeTypeValue>
                                    </div>
                                  </div>


                                </div>
                              </div>
                              <div class="row">
                                <div class="form-group col-md-12 col-xs-12 margin-bottom-5px">
                                  <div class="row">
                                    <div class="col-md-5 text-align-right">
                                      <label for="diaplayName"><span>*</span> Marital Status</label>
                                    </div>

                                    <div class="col-md-7">
                                      <CodeTypeValue CodeType="MARTL"
                                                     id="CurrentSavePatientInfoRequest.MaritalStatus" PassType="Long"
                                                     [(ngModel)]="CurrentSavePatientInfoRequest.MaritalStatus" SelectedValue="{{CurrentSavePatientInfoRequest.MaritalStatus}}"
                                                     name="CurrentSavePatientInfoRequest.MaritalStatus" required #Status="ngModel">
                                      </CodeTypeValue>

                                    </div>
                                  </div>


                                </div>
                              </div>
                              <div class="row">
                                <div class="form-group col-md-12 col-xs-12 margin-bottom-5px">

                                  <div class="row">
                                    <div class="col-md-5 text-align-right">
                                      <label for="diaplayName">Nationality</label>
                                    </div>

                                    <div class="col-md-7">
                                      <CodeTypeValue CodeType="NATN"
                                                     id="CurrentSavePatientInfoRequest.Nationality" PassType="Long"
                                                     [(ngModel)]="CurrentSavePatientInfoRequest.Nationality" SelectedValue="{{CurrentSavePatientInfoRequest.Nationality}}"
                                                     name="CurrentSavePatientInfoRequest.Nationality">
                                      </CodeTypeValue>
                                    </div>
                                  </div>


                                </div>
                              </div>
                              <div class="row">
                                <div class="form-group col-md-12 col-xs-12 margin-bottom-5px">
                                  <div class="row">

                                    <div class="col-md-5 text-align-right">
                                      <label for="email address">Primary Care Giver</label>
                                    </div>
                                    <!--<div class="col-md-7">
          <input type="text" class="form-control" placeholder="Primary Care Giver"
                 id="CurrentSavePatientInfoRequest.PrimaryDoctor"
                 [(ngModel)]="CurrentSavePatientInfoRequest.PrimaryDoctor"
                 name="CurrentSavePatientInfoRequest.PrimaryDoctor" pattern="^[\sa-zA-Z0-9,._\-?]*$"
                 maxlength="20" minlength="1">
        </div>-->
                                    <div class="col-md-5">
                                      <label class="font-size-14 margin-bottom-0px" *ngIf="PrimaryDoctorn">{{PrimaryDoctor}}</label>
                                      <label class="font-size-14 margin-bottom-0px" *ngIf="PrimaryDoctorO">{{CurrentSavePatientInfoRequest.PrimaryDoctor}}</label>
                                    </div>
                                    <div class="col-md-2">
                                      <button type="button" class="btn btn-secondary font-size-13px btn-raised button-Schedule action-button-prime-cycle actions-btn-prime3  " (click)="SelectPrimaryDoctor()"> <i class="fas fa-ellipsis-h"></i></button>
                                    </div>
                                  </div>
                                </div>
                              </div>
                              <div class="row">
                                <div class="form-group col-md-12 col-xs-12 margin-bottom-5px">
                                  <div class="row">

                                    <div class="col-md-5 text-align-right">
                                     <label for="email address" class="margin-bottom-0px margin-top-3px">Birth Identification</label>
                                    </div>
                                    <div class="col-md-7">
                                      <input type="text" class="form-control" placeholder="BirthIdentification"
                                             id="CurrentSavePatientInfoRequest.BirthIdentification1"
                                             [(ngModel)]="CurrentSavePatientInfoRequest.BirthIdentification1"
                                             name="CurrentSavePatientInfoRequest.BirthIdentification1" pattern="^[\sa-zA-Z0-9,._\-?]*$"
                                             maxlength="30" minlength="1">
                                    </div>
                                  </div>
                                </div>
                              </div>
                              <div class="row">
                                <div class="form-group col-md-12 col-xs-12 margin-bottom-5px">

                                  <div class="row">
                                    <div class="col-md-5 text-align-right">
                                      <label for="diaplayName" class="margin-bottom-0px margin-top-3px">ID Proof</label>
                                    </div>

                                    <div class="col-md-7">
                                      <input type="text" class="form-control" placeholder="ID Proof"
                                             id="CurrentSavePatientInfoRequest.IdProof"
                                             [(ngModel)]="CurrentSavePatientInfoRequest.IdProof"
                                             name="CurrentSavePatientInfoRequest.IdProof" pattern="^[\sa-zA-Z0-9,._\-?]*$"
                                             maxlength="30" minlength="1">

                                    </div>
                                  </div>


                                </div>
                              </div>
                              <!--<div class="row">

    <div class="form-group col-md-12 col-xs-12 margin-bottom-5px">
      <div class="row">
        <div class="col-md-5 text-align-right">
          <label for="diaplayName"><span>*</span> Mother Tongue</label>
        </div>

        <div class="col-md-7">
          <input type="text" class="form-control" minlength="2" placeholder="Mother Tongue">

        </div>
      </div>


    </div>
  </div>-->
                              <!--<div class="row">
    <div class="form-group col-md-12 col-xs-12 margin-bottom-5px">

      <div class="row">
        <div class="col-md-5 text-align-right">
          <label for="diaplayName">Languages Known</label>
        </div>

        <div class="col-md-7">
          <input type="text" class="form-control" minlength="2" placeholder="Languages Known"
                 id="CurrentSavePatientInfoRequest.Language"
                 [(ngModel)]="CurrentSavePatientInfoRequest.Language"
                 name="CurrentSavePatientInfoRequest.Language" pattern="^[\sa-zA-Z0-9,._\-?]*$"
                 maxlength="20">
        </div>
      </div>


    </div>
  </div>-->
                            </div>
                          </div>
                        </div>
                        <div class="card-footer">
                          <button type="button" class="btn btn-secondary btn-raised float-right margin-left-3px button-Schedule actions-btn-prime actions-btn-prime3 margin-left-auto font-size-13px" (click)="activeModal.close('Close click')">Close</button>
                          <button type="submit" class="btn actions-btn-prime float-right font-size-13px" [disabled]="Name.errors?.required || Birthp.errors?.required || Prefix.errors?.required || Sex.errors?.required || Status.errors?.required">Save</button>
                        </div>
                      </div>
                    </form>
                  </div>
                </div>
              </div>
              <!--<div class="card-footer text-align-center">
                <button type="button" class="btn btn-secondary btn-raised button-Schedule actions-btn-prime actions-btn-prime3 margin-left-auto" (click)="activeModal.close('Close click')">Close</button>
              </div>-->
            </div>


          </div>

          <div class="tab-pane" id="Education">

            <form class="form" novalidate="" (ngSubmit)="Education()" #f="ngForm">

              <div class="card card-height-417px">

                <div class="card-body margin-left-zero padding-left-0px padding-right-0px padding-bottom-0px">
                  <div class="row">
                    <div class="col-md-12 padding-l-0px">
                      <div class="card col-xl-12 col-lg-12 col-md-12 col-sm-12 my-profile-form padding-lr-0px">

                        <div class="card-body card-body-general">
                          <div class="row">
                            <div class="form-group col-md-12 col-xs-12 margin-bottom-5px">
                              <div class="row">
                                <div class="col-md-3 text-align-right">
                                  <label for="diaplayName">Education Level</label>
                                </div>
                                <div class="col-md-3">
                                  <CodeTypeValue CodeType="EDU"
                                                 id="CurrentSavePatientInfoRequest.EducationTitle" PassType="Long"
                                                 [(ngModel)]="CurrentSavePatientInfoRequest.EducationTitle" SelectedValue="{{CurrentSavePatientInfoRequest.EducationTitle}}"
                                                 name="CurrentSavePatientInfoRequest.EducationTitle">
                                  </CodeTypeValue>
                                </div>
                              </div>


                            </div>
                          </div>

                          <div class="row">
                            <div class="form-group col-md-12 col-xs-12 margin-bottom-5px">
                              <div class="row">

                                <div class="col-md-3 text-align-right">
                                  <label for="email address">Education in Detail</label>
                                </div>
                                <div class="col-md-3">
                                  <input type="text" class="form-control" placeholder="Details"
                                         id="CurrentSavePatientInfoRequest.EducationInDetail"
                                         [(ngModel)]="CurrentSavePatientInfoRequest.EducationInDetail"
                                         name="CurrentSavePatientInfoRequest.EducationInDetail" pattern="^[\sa-zA-Z0-9,._\-?]*$"
                                         maxlength="30" minlength="1">
                                </div>
                              </div>
                            </div>
                          </div>

                        </div>
                      </div>

                    </div>
                  </div>

                </div>
                <div class="card-footer">
                  <button type="button" class="btn btn-secondary btn-raised float-right margin-left-3px button-Schedule actions-btn-prime actions-btn-prime3 margin-left-auto font-size-13px" (click)="activeModal.close('Close click')">Close</button>
                  <button type="submit" class="btn actions-btn-prime float-right font-size-13px">Save</button>
                </div>
              </div>

            </form>





          </div>

          <div class="tab-pane" id="Registration">

            <form class="form" novalidate="" #f="ngForm">

              <div class="card col-xl-12 col-lg-12 col-md-12 col-sm-12 my-profile-form padding-lr-0px">

                <div class="card-body margin-left-zero padding-left-0px padding-right-0px padding-bottom-0px">
                  <div class="row">
                    <div class="col-md-12">
                      <div *canUserAccess="['HL_REG_20']" class="card col-xl-12 col-lg-12 col-md-12 col-sm-12 my-profile-form padding-lr-0px border-1px-gray">

                        <div class="card-body card-body-general">
                          <div class="row">
                            <div class="form-group col-md-12 col-xs-12 margin-bottom-5px">
                              <div class="row">

                                <div class="col-md-3 text-align-right">
                                  <label for="email address">Current Formatted Code</label>
                                </div>
                                <div class="col-md-3">
                                  <label class="margin-bottom-0px">{{FormattedCode}}</label>
                                </div>
                              </div>
                            </div>
                          </div>
                          <div class="row">
                            <div class="form-group col-md-12 col-xs-12 margin-bottom-5px">
                              <div class="row">

                                <div class="col-md-3 text-align-right">
                                  <label for="email address">New FormattedCode</label>
                                </div>
                                <div class="col-md-3">
                                  <input type="text" class="form-control" placeholder="New FormattedCode"
                                         id="NewFormattedCode"
                                         [(ngModel)]="NewFormattedCode"
                                         name="NewFormattedCode" pattern="^[\sa-zA-Z0-9,._\-?]*$"
                                         maxlength="20" minlength="1">
                                </div>
                              </div>
                            </div>
                          </div>

                          <div class="row margin-right-0px">
                            <div class="col-md-12 float-right padding-bottom-5px">
                              <button type="button" (click)="UpdateRegistration()" class="btn actions-btn-prime float-right font-size-13px">Save</button>
                            </div>
                          </div>

                          <div class="row" hidden>
                            <div class="form-group col-md-12 col-xs-12 margin-bottom-5px">
                              <div class="row">

                                <div class="col-md-4 text-align-right">
                                  <label for="email address">Change Registration Type To</label>
                                </div>
                                <div class="col-md-3">
                                  <CodeTypeValue CodeType="DONTY"
                                                 id="CurrentSaveActorRegistationType.DonorType"
                                                 [(ngModel)]="CurrentSaveActorRegistationType.DonorType"
                                                 name="CurrentSaveActorRegistationType.DonorType">
                                  </CodeTypeValue>
                                </div>
                              </div>
                            </div>
                          </div>
                          <div class="row" hidden>
                            <div class="form-group col-md-12 col-xs-12 margin-bottom-5px">
                              <div class="row">

                                <div class="col-md-3 text-align-right">
                                  <label for="email address">Registration Type</label>
                                </div>
                                <div class="col-md-3">
                                  <CodeTypeValue CodeType="REGTY"
                                                 id="CurrentSavePatientInfoRequest.RegistrationType"
                                                 [(ngModel)]="CurrentSavePatientInfoRequest.RegistrationType" SelectedValue="{{CurrentSavePatientInfoRequest.RegistrationType}}"
                                                 name="CurrentSavePatientInfoRequest.RegistrationType">
                                  </CodeTypeValue>
                                </div>
                              </div>
                            </div>
                          </div>
                          <div class="row" hidden>
                            <div class="form-group col-md-12 col-xs-12 margin-bottom-5px">
                              <div class="row">

                                <div class="col-md-3 text-align-right">
                                  <label for="email address">Registration Reason</label>
                                </div>
                                <div class="col-md-3">
                                  <CodeTypeValue CodeType="REGRS"
                                                 id="CurrentSavePatientInfoRequest.RegistrationReason"
                                                 [(ngModel)]="CurrentSavePatientInfoRequest.RegistrationReason" SelectedValue="{{CurrentSavePatientInfoRequest.RegistrationReason}}"
                                                 name="CurrentSavePatientInfoRequest.RegistrationReason">
                                  </CodeTypeValue>
                                </div>
                              </div>
                            </div>
                          </div>
                          <div class="row" hidden>
                            <div class="form-group col-md-12 col-xs-12 margin-bottom-5px">
                              <div class="row">

                                <div class="col-md-3 text-align-right">
                                  <label for="email address">Registration Current</label>
                                </div>
                                <div class="col-md-3">
                                  <CodeTypeValue CodeType="REGRS"
                                                 id="CurrentSavePatientInfoRequest.RegistrationReason"
                                                 [(ngModel)]="CurrentSavePatientInfoRequest.RegistrationReason" SelectedValue="{{CurrentSavePatientInfoRequest.RegistrationReason}}"
                                                 name="CurrentSavePatientInfoRequest.RegistrationReason">
                                  </CodeTypeValue>
                                </div>
                              </div>
                            </div>
                          </div>
                          <div class="row" hidden>
                            <div class="form-group col-md-12 col-xs-12 margin-bottom-5px">
                              <div class="row">

                                <div class="col-md-3 text-align-right">
                                  <label for="email address">Billing Category</label>
                                </div>
                                <div class="col-md-3">
                                  <CodeTypeValue CodeType="CATAV"
                                                 id="CurrentSavePatientInfoRequest.BillingCategory"
                                                 [(ngModel)]="CurrentSavePatientInfoRequest.BillingCategory" SelectedValue="{{CurrentSavePatientInfoRequest.BillingCategory}}"
                                                 name="CurrentSavePatientInfoRequest.BillingCategory">
                                  </CodeTypeValue>
                                </div>
                              </div>
                            </div>
                          </div>
                          <div class="row" hidden>
                            <div class="form-group col-md-12 col-xs-12 margin-bottom-5px">
                              <div class="row">

                                <div class="col-md-3 text-align-right">
                                  <label for="email address">Registration Validity</label>
                                </div>
                                <div class="col-md-3">
                                  <div class="date-form">
                                    <input class="form-control" placeholder="Registration Validity" [minDate]="minDate" [maxDate]="maxDate"
                                           name="dp3" [(ngModel)]="RegistrationVal" ngbDatepicker #d="ngbDatepicker" #DateOf="ngModel">
                                    <!--<small class="form-text text-danger"
                *ngIf="(!DateOfBirth.valid && (DateOfBirth.dirty || DateOfBirth.touched) && DateOfBirth.errors.required)">(Field cannot be left blank)</small>-->

                                    <a (click)="d.toggle()" class="nav-link-hand">
                                      <span class="date-icon"><i class="far fa-calendar-alt"></i></span>

                                    </a>

                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                          <div class="row" hidden>
                            <div class="form-group col-md-12 col-xs-12 margin-bottom-5px">
                              <div class="row">
                                <div class="col-md-3 text-align-right">
                                  <label for="diaplayName" class="margin-top-3px margin-bottom-0px">Is Old Registration</label>
                                </div>
                                <div class="col-md-1">
                                  <input type="checkbox" class="width-15px" [(ngModel)]="CurrentSavePatientInfoRequest.IsOldRegistration" name="CurrentSavePatientInfoRequest.IsOldRegistration">
                                </div>
                              </div>


                            </div>
                          </div>

                          <div class="row" *ngIf="CurrentSavePatientInfoRequest.IsOldRegistration" hidden>
                            <div class="form-group col-md-12 col-xs-12 margin-bottom-5px">
                              <div class="row">

                                <div class="col-md-3 text-align-right">
                                  <label for="email address">Old Registration No</label>
                                </div>
                                <div class="col-md-3">
                                  <input type="number" class="form-control" minlength="2" placeholder="Old Reg Number"
                                         id="CurrentSavePatientInfoRequest.OldRegistrationNumber"
                                         [(ngModel)]="CurrentSavePatientInfoRequest.OldRegistrationNumber"
                                         name="CurrentSavePatientInfoRequest.OldRegistrationNumber" pattern="^[\sa-zA-Z0-9,._\-?]*$"
                                         maxlength="20">
                                </div>
                              </div>
                            </div>
                          </div>
                          <div class="row" hidden>
                            <div class="form-group col-md-12 col-xs-12 margin-bottom-5px">
                              <div class="row">

                                <div class="col-md-3 text-align-right">
                                  <label for="email address">Primary Care Giver</label>
                                </div>
                                <div class="col-md-3">
                                  <input type="text" class="form-control" placeholder="Primary Care Giver"
                                         id="CurrentSavePatientInfoRequest.PrimaryDoctor"
                                         [(ngModel)]="CurrentSavePatientInfoRequest.PrimaryDoctor"
                                         name="CurrentSavePatientInfoRequest.PrimaryDoctor" pattern="^[\sa-zA-Z0-9,._\-?]*$"
                                         maxlength="20" minlength="1">
                                </div>
                              </div>
                            </div>
                          </div>
                          <div class="row" hidden>
                            <div class="form-group col-md-12 col-xs-12 margin-bottom-5px">
                              <div class="row">
                                <div class="col-md-3 text-align-right">
                                  <label for="diaplayName" class="margin-top-3px margin-bottom-0px">Is Insured</label>
                                </div>
                                <div class="col-md-1">
                                  <input type="checkbox" class="width-15px" [(ngModel)]="CurrentSavePatientInfoRequest.IsInsured" name="CurrentSavePatientInfoRequest.IsInsured">
                                </div>
                              </div>


                            </div>
                          </div>

                          <div class="row" *ngIf="CurrentSavePatientInfoRequest.IsInsured" hidden>
                            <div class="form-group col-md-12 col-xs-12 margin-bottom-5px">
                              <div class="row">

                                <div class="col-md-3 text-align-right">
                                  <label for="email address">Insurance Provider</label>
                                </div>
                                <div class="col-md-3">
                                  <CodeTypeValue CodeType="INLST"
                                                 id="CurrentSavePatientInfoRequest.InsuranceProvider"
                                                 [(ngModel)]="CurrentSavePatientInfoRequest.InsuranceProvider" SelectedValue="{{CurrentSavePatientInfoRequest.InsuranceProvider}}"
                                                 name="CurrentSavePatientInfoRequest.InsuranceProvider">
                                  </CodeTypeValue>
                                </div>
                              </div>
                            </div>
                          </div>
                          <div class="row" hidden>
                            <div class="form-group col-md-12 col-xs-12 margin-bottom-5px">
                              <div class="row">

                                <div class="col-md-3 text-align-right">
                                  <label for="email address">Wedding Date</label>
                                </div>
                                <div class="col-md-3">
                                  <div class="date-form">
                                    <input class="form-control" placeholder="Wedding Date" [minDate]="minDate" [maxDate]="maxDate"
                                           name="dp2" [(ngModel)]="WeddingDate" ngbDatepicker #d="ngbDatepicker" #DateOfBirth="ngModel">
                                    <!--<small class="form-text text-danger"
                *ngIf="(!DateOfBirth.valid && (DateOfBirth.dirty || DateOfBirth.touched) && DateOfBirth.errors.required)">(Field cannot be left blank)</small>-->

                                    <a (click)="d.toggle()" class="nav-link-hand">
                                      <span class="date-icon"><i class="far fa-calendar-alt"></i></span>

                                    </a>

                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>

                      <div *canUserAccess="['HL_REG_BILLCATEGORY']"
                           class="card col-xl-12 col-lg-12 col-md-12 col-sm-12 my-profile-form padding-lr-0px  border-1px-gray">

                        <div class="card-body card-body-general">
                          <div class="row">
                            <div class="form-group col-md-12 col-xs-12 margin-bottom-5px">
                              <div class="row">

                                <div class="col-md-3 text-align-right">
                                  <label for="email address">Billing Category</label>
                                </div>
                                <div class="col-md-3">
                                  <CodeTypeValue CodeType="CATAV"
                                                 id="CurrentUpdateBillingCategory.BillingCategory"
                                                 [(ngModel)]="CurrentUpdateBillingCategory.BillingCategory"
                                                 name="CurrentUpdateBillingCategory.BillingCategory">
                                  </CodeTypeValue>
                                </div>
                              </div>
                            </div>
                          </div>
                          <div class="row margin-right-0px">
                            <div class="col-md-12 float-right padding-bottom-5px">
                              <button type="button" (click)="UpdateBillingCategory()" class="btn actions-btn-prime float-right font-size-13px">Save</button>
                            </div>
                          </div>

                        </div>
                      </div>

                      <div *canUserAccess="['HL_REG_WeddingDate']"
                           class="card col-xl-12 col-lg-12 col-md-12 col-sm-12 my-profile-form padding-lr-0px  border-1px-gray">

                        <div class="card-body card-body-general">
                          <div class="row">
                            <div class="form-group col-md-12 col-xs-12 margin-bottom-5px">
                              <div class="row">

                                <div class="col-md-3 text-align-right">
                                  <label for="email address">Wedding Date</label>
                                </div>
                                <div class="col-md-3">
                                  <label class="margin-bottom-0px">{{CurrentUpdateWeddingDate.WeddingDate | date:'dd-MMM-yyyy'}}</label>
                                </div>
                              </div>
                            </div>
                          </div>
                          <div class="row">
                            <div class="form-group col-md-12 col-xs-12 margin-bottom-5px">
                              <div class="row">
                                <div class="col-md-3 text-align-right">
                                  <label for="email address">Change Wedding Date</label>
                                </div>
                                <div class="col-md-3">
                                  <div class="date-form">
                                    <input class="form-control" placeholder="Wedding Date" [minDate]="minDate" [maxDate]="maxDate"
                                           name="dp2" [(ngModel)]="WeddingDate" ngbDatepicker #d="ngbDatepicker" #DateOfBirth="ngModel">
                                    <a (click)="d.toggle()" class="nav-link-hand">
                                      <span class="date-icon"><i class="far fa-calendar-alt"></i></span>
                                    </a>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                          <div class="row margin-right-0px">
                            <div class="col-md-12 float-right padding-bottom-5px">
                              <button type="button" (click)="UpdateWeddingDate()" class="btn actions-btn-prime float-right font-size-13px">Save</button>
                            </div>
                          </div>

                        </div>
                      </div>

                    </div>
                  </div>

                </div>
                <!--<div class="card-footer">
                  <button type="button" class="btn btn-secondary btn-raised float-right margin-left-3px button-Schedule actions-btn-prime actions-btn-prime3 margin-left-auto font-size-13px" (click)="activeModal.close('Close click')">Close</button>
                  <button type="submit" class="btn actions-btn-prime float-right font-size-13px">Save</button>
                </div>-->
              </div>

            </form>



          </div>

          <div class="tab-pane" id="Overseas">

            <form class="form" novalidate="" #f="ngForm">

              <div class="card card-height-417px">

                <div class="card-body margin-left-zero padding-left-0px padding-right-0px padding-bottom-0px">
                  <div class="row">
                    <div class="col-md-12 padding-l-0px">
                      <div class="card col-xl-12 col-lg-12 col-md-12 col-sm-12 my-profile-form padding-lr-0px">

                        <div class="card-body card-body-general">
                          <div class="row" hidden>
                            <div class="form-group col-md-12 col-xs-12 margin-bottom-5px">
                              <div class="row">
                                <div class="col-md-3 text-align-right">
                                  <label for="diaplayName" class="margin-top-3px margin-bottom-0px">If Overseas Patient</label>
                                </div>
                                <div class="col-md-1">
                                  <input type="checkbox" class="width-15px">
                                </div>
                              </div>


                            </div>
                          </div>
                          <div class="row">
                            <div class="form-group col-md-12 col-xs-12 margin-bottom-5px">

                              <div class="row">
                                <div class="col-md-3 text-align-right">
                                  <label for="diaplayName">Passport Number</label>
                                </div>

                                <div class="col-md-3">
                                  <input type="text" class="form-control" placeholder="Passport Number"
                                         id="CurrentUpdateOverseas.PassportNumber"
                                         [(ngModel)]="CurrentUpdateOverseas.PassportNumber"
                                         name="CurrentUpdateOverseas.PassportNumber" pattern="^[\sa-zA-Z0-9,._\-?]*$"
                                         maxlength="20" minlength="1">


                                </div>
                              </div>


                            </div>
                          </div>
                          <div class="row">
                            <div class="form-group col-md-12 col-xs-12 margin-bottom-5px">

                              <div class="row">
                                <div class="col-md-3 text-align-right">
                                  <label for="diaplayName">Expiry Date</label>
                                </div>

                                <div class="col-md-3">
                                  <div class="date-form">
                                    <input class="form-control" placeholder="Expiry Date" [minDate]="minDate"
                                           name="dp" [(ngModel)]="PassportExpiryDate" ngbDatepicker #d="ngbDatepicker" #DateOfBirth="ngModel">
                                    <!--<small class="form-text text-danger"
                                    *ngIf="(!DateOfBirth.valid && (DateOfBirth.dirty || DateOfBirth.touched) && DateOfBirth.errors.required)">(Field cannot be left blank)</small>-->

                                    <a (click)="d.toggle()" class="nav-link-hand">
                                      <span class="date-icon"><i class="far fa-calendar-alt"></i></span>

                                    </a>

                                  </div>
                                </div>
                              </div>


                            </div>
                          </div>
                          <div class="row">
                            <div class="form-group col-md-12 col-xs-12 margin-bottom-5px">
                              <div class="row">

                                <div class="col-md-3 text-align-right">
                                  <label for="email address">Issue Country</label>
                                </div>
                                <div class="col-md-3">
                                  <CodeTypeValue CodeType="CNTR"
                                                 id="CurrentUpdateOverseas.IssueCountry"
                                                 [(ngModel)]="CurrentUpdateOverseas.IssueCountry"
                                                 name="CurrentUpdateOverseas.IssueCountry"></CodeTypeValue>
                                </div>
                              </div>
                            </div>
                          </div>
                          <div class="row">
                            <div class="form-group col-md-12 col-xs-12 margin-bottom-5px">
                              <div class="row">

                                <div class="col-md-3 text-align-right">
                                  <label for="email address">Visa Type</label>
                                </div>
                                <div class="col-md-3">
                                  <CodeTypeValue CodeType="Visa Type"
                                                 id="CurrentUpdateOverseas.VisaType"
                                                 [(ngModel)]="CurrentUpdateOverseas.VisaType"
                                                 name="CurrentUpdateOverseas.VisaType"></CodeTypeValue>
                                </div>
                              </div>
                            </div>
                          </div>
                          <div class="row">
                            <div class="form-group col-md-12 col-xs-12 margin-bottom-5px">

                              <div class="row">
                                <div class="col-md-3 text-align-right">
                                  <label for="diaplayName">Visa Expiry Date</label>
                                </div>

                                <div class="col-md-3">
                                  <div class="date-form">
                                    <input class="form-control" placeholder="Visa Expiry Date" [minDate]="minDate"
                                           name="dp1" [(ngModel)]="VisaExpiryDate" ngbDatepicker #d1="ngbDatepicker" #DateOfBirth1="ngModel">
                                    <!--<small class="form-text text-danger"
                                    *ngIf="(!DateOfBirth.valid && (DateOfBirth.dirty || DateOfBirth.touched) && DateOfBirth.errors.required)">(Field cannot be left blank)</small>-->

                                    <a (click)="d1.toggle()" class="nav-link-hand">
                                      <span class="date-icon"><i class="far fa-calendar-alt"></i></span>

                                    </a>

                                  </div>
                                </div>
                              </div>


                            </div>
                          </div>
                          <div class="row">
                            <div class="form-group col-md-12 col-xs-12 margin-bottom-5px">
                              <div class="row">

                                <div class="col-md-3 text-align-right">
                                  <label for="email address">National Reg No</label>
                                </div>
                                <div class="col-md-3">
                                  <input type="text" class="form-control" placeholder="National Reg No"
                                         id="CurrentUpdateOverseas.NationalRegNo"
                                         [(ngModel)]="CurrentUpdateOverseas.NationalRegNo"
                                         name="CurrentUpdateOverseas.NationalRegNo" pattern="^[\sa-zA-Z0-9,._\-?]*$"
                                         maxlength="20" minlength="1">
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>

                    </div>
                  </div>

                </div>
                <div class="card-footer">
                  <button type="button" class="btn btn-secondary btn-raised float-right margin-left-3px button-Schedule actions-btn-prime actions-btn-prime3 margin-left-auto font-size-13px" (click)="activeModal.close('Close click')">Close</button>
                  <button type="button" (click)="UpdateOverseas()" class="btn actions-btn-prime float-right font-size-13px">Save</button>
                </div>
              </div>

            </form>



          </div>

          <div class="tab-pane" id="Referral">

            <form class="form" novalidate="" (ngSubmit)="Referral()" #f="ngForm">

              <div class="card card-height-417px">

                <div class="card-body margin-left-zero padding-left-0px padding-right-0px padding-bottom-0px">
                  <div class="row">
                    <div class="col-md-12 padding-l-0px">
                      <div class="card col-xl-12 col-lg-12 col-md-12 col-sm-12 my-profile-form padding-lr-0px">

                        <div class="card-body card-body-general">
                          <div class="row">
                            <div class="form-group col-md-12 col-xs-12 margin-bottom-5px">
                              <div class="row">
                                <div class="col-md-3 text-align-right">
                                  <label for="diaplayName">Referral Type</label>
                                </div>
                                <div class="col-md-3">
                                  <CodeTypeValue CodeType="RFTP" (ngModelChange)="onChange2($event)" PassType="Long"
                                                 id="CurrentSavePatientInfoRequest.RefType"
                                                 [(ngModel)]="CurrentSavePatientInfoRequest.RefType" SelectedValue="{{CurrentSavePatientInfoRequest.RefType}}"
                                                 name="CurrentSavePatientInfoRequest.RefType">
                                  </CodeTypeValue>
                                </div>
                              </div>


                            </div>
                          </div>
                          <div class="row" *ngIf="SelectedSource=='CMP' || SelectedSource=='FRND' || SelectedSource=='MEDHD' || SelectedSource=='MEDNP' || SelectedSource=='MEDNT' || SelectedSource=='MEDRD' || SelectedSource=='MEDTV'">
                            <div class="form-group col-md-12 col-xs-12 margin-bottom-5px">
                              <div class="row">

                                <div class="col-md-3 text-align-right">
                                  <label for="email address">Referral Details </label>
                                </div>
                                <div class="col-md-3">
                                  <input type="text" class="form-control" placeholder="Referral By"
                                         id="CurrentSavePatientInfoRequest.RefDetails"
                                         [(ngModel)]="CurrentSavePatientInfoRequest.RefDetails"
                                         name="CurrentSavePatientInfoRequest.RefDetails" pattern="^[\sa-zA-Z0-9,._\-?]*$"
                                         maxlength="30" minlength="1">
                                  <!--{{ProviderName1}}-->
                                </div>
                                <!--<div class="col-md-2">
                                  <button type="button" class="btn btn-secondary font-size-13px btn-raised button-Schedule action-button-prime-cycle actions-btn-prime3  " (click)="SelectExternalDoctor()"> <i class="fas fa-ellipsis-h"></i></button>
                                </div>-->
                              </div>
                            </div>
                          </div>
                          <div class="row" *ngIf="SelectedSource=='RGPT'">
                            <div class="form-group col-md-12 col-xs-12 margin-bottom-5px">
                              <div class="row">

                                <div class="col-md-3 text-align-right">
                                  <label for="email address">Referred By </label>
                                </div>
                                <div class="col-md-3">
                                  <!--<input type="text" class="form-control" placeholder="Referral By"
                                  id="CurrentSavePatientInfoRequest.RefDetails"
                                  [(ngModel)]="CurrentSavePatientInfoRequest.RefDetails"
                                  name="CurrentSavePatientInfoRequest.RefDetails" pattern="^[\sa-zA-Z0-9,._\-?]*$"
                                  maxlength="20" minlength="1">-->
                                  <label class="font-size-14 margin-bottom-0px">{{PatientName}}</label>
                                </div>
                                <div class="col-md-2">
                                  <button type="button" class="btn btn-secondary font-size-13px btn-raised button-Schedule action-button-prime-cycle actions-btn-prime3  " (click)="SelectPatient()"> <i class="fas fa-ellipsis-h"></i></button>
                                </div>
                              </div>
                            </div>
                          </div>
                          <div class="row" *ngIf="SelectedSource=='STAFF'">
                            <div class="form-group col-md-12 col-xs-12 margin-bottom-5px">
                              <div class="row">

                                <div class="col-md-3 text-align-right">
                                  <label for="email address">Referred By </label>
                                </div>
                                <div class="col-md-3">
                                  <!--<input type="text" class="form-control" placeholder="Referral By"
                                  id="CurrentSavePatientInfoRequest.RefDetails"
                                  [(ngModel)]="CurrentSavePatientInfoRequest.RefDetails"
                                  name="CurrentSavePatientInfoRequest.RefDetails" pattern="^[\sa-zA-Z0-9,._\-?]*$"
                                  maxlength="20" minlength="1">-->
                                  <label class="font-size-14 margin-bottom-0px">{{StaffName}}</label>
                                </div>
                                <div class="col-md-2">
                                  <button type="button" class="btn btn-secondary font-size-13px btn-raised button-Schedule action-button-prime-cycle actions-btn-prime3  " (click)="SelectStaff()"> <i class="fas fa-ellipsis-h"></i></button>
                                </div>
                              </div>
                            </div>
                          </div>
                          <div class="row" *ngIf="SelectedSource=='DOC'">
                            <div class="form-group col-md-12 col-xs-12 margin-bottom-5px">
                              <div class="row">

                                <div class="col-md-3 text-align-right">
                                  <label for="email address">Referred By </label>
                                </div>
                                <div class="col-md-3">
                                  <!--<input type="text" class="form-control" placeholder="Referral By"
                                  id="CurrentSavePatientInfoRequest.RefDetails"
                                  [(ngModel)]="CurrentSavePatientInfoRequest.RefDetails"
                                  name="CurrentSavePatientInfoRequest.RefDetails" pattern="^[\sa-zA-Z0-9,._\-?]*$"
                                  maxlength="20" minlength="1">-->
                                  <label class="font-size-14 margin-bottom-0px">{{ProviderName}}</label>
                                </div>
                                <div class="col-md-2">
                                  <button type="button" class="btn btn-secondary font-size-13px btn-raised button-Schedule action-button-prime-cycle actions-btn-prime3  " (click)="SelectInternalDoctor()"> <i class="fas fa-ellipsis-h"></i></button>
                                </div>
                              </div>
                            </div>
                          </div>
                          <div class="row" *ngIf="SelectedSource=='DOCEX'">
                            <div class="form-group col-md-12 col-xs-12 margin-bottom-5px">
                              <div class="row">

                                <div class="col-md-3 text-align-right">
                                  <label for="email address">Referred By </label>
                                </div>
                                <div class="col-md-3">
                                  <input type="text" class="form-control" placeholder="Referral By"
                                  id="CurrentSavePatientInfoRequest.RefDetails"
                                  [(ngModel)]="CurrentSavePatientInfoRequest.RefDetails"
                                  name="CurrentSavePatientInfoRequest.RefDetails" pattern="^[\sa-zA-Z0-9,._\-?]*$"
                                  maxlength="30" minlength="1">
                                  <!--<label class="font-size-14 margin-bottom-0px">{{ProviderName1}}</label>-->
                                </div>
                                <div class="col-md-2">
                                  <button type="button" class="btn btn-secondary font-size-13px btn-raised button-Schedule action-button-prime-cycle actions-btn-prime3  " (click)="SelectExternalDoctor()"> <i class="fas fa-ellipsis-h"></i></button>
                                </div>
                              </div>
                            </div>
                          </div>
                          <!--<div class="row" *ngIf="SelectedSource=='DOC'">
                            <div class="form-group col-md-12 col-xs-12 margin-bottom-5px">
                              <div class="row">

                                <div class="col-md-3 text-align-right">
                                  <label for="email address">Clinic Name </label>
                                </div>
                                <div class="col-md-3">

                                </div>
                              </div>
                            </div>
                          </div>-->
                          <div class="row" *ngIf="SelectedSource=='DOC'">
                            <div class="form-group col-md-12 col-xs-12 margin-bottom-5px">
                              <div class="row">

                                <div class="col-md-3 text-align-right">
                                  <label for="email address">Referral Contact</label>
                                </div>
                                <div class="col-md-3">
                                  <label class="font-size-14 margin-bottom-0px">{{ProviderNumber}}</label>

                                </div>
                              </div>
                            </div>
                          </div>
                          <div class="row" *ngIf="SelectedSource=='DOCEX'">
                            <div class="form-group col-md-12 col-xs-12 margin-bottom-5px">
                              <div class="row">

                                <div class="col-md-3 text-align-right">
                                  <label for="email address">Referral Contact</label>
                                </div>
                                <div class="col-md-3">
                                  <input type="tel" class="form-control" placeholder="Mobile Phone"
                                         id="CurrentSavePatientInfoRequest.RefContactNo"
                                         [(ngModel)]="CurrentSavePatientInfoRequest.RefContactNo"
                                         mask="(000) 000-0000"
                                         name="CurrentSavePatientInfoRequest.RefContactNo" pattern="[0-9]{10}" #Telephone1="ngModel">
                                  <small class="form-text text-danger"
                                         *ngIf="(!Telephone1.valid)">(Provide Valid CellNo)</small>
                                  <!--<label class="font-size-14 margin-bottom-0px">{{ProviderNumber1}}</label>-->

                                </div>
                              </div>
                            </div>
                          </div>
                          <div class="row" *ngIf="SelectedSource=='STAFF'">
                            <div class="form-group col-md-12 col-xs-12 margin-bottom-5px">
                              <div class="row">

                                <div class="col-md-3 text-align-right">
                                  <label for="email address">Referral Contact</label>
                                </div>
                                <div class="col-md-3">
                                  <label class="font-size-14 margin-bottom-0px">{{StaffNumber}}</label>

                                </div>
                              </div>
                            </div>
                          </div>
                          <div class="row" *ngIf="SelectedSource=='RGPT'">
                            <div class="form-group col-md-12 col-xs-12 margin-bottom-5px">
                              <div class="row">

                                <div class="col-md-3 text-align-right">
                                  <label for="email address">Referral Contact</label>
                                </div>
                                <div class="col-md-3">
                                  <label class="font-size-14 margin-bottom-0px">{{PatientNumber}}</label>

                                </div>
                              </div>
                            </div>
                          </div>
                          <div class="row" *ngIf="SelectedSource=='CMP' || SelectedSource=='FRND' || SelectedSource=='MEDHD' || SelectedSource=='MEDNP' || SelectedSource=='MEDNT' || SelectedSource=='MEDRD' || SelectedSource=='MEDTV'">
                            <div class="form-group col-md-12 col-xs-12 margin-bottom-5px">
                              <div class="row">

                                <div class="col-md-3 text-align-right">
                                  <label for="email address">Referral Contact</label>
                                </div>
                                <div class="col-md-3">
                                  <!--<input type="tel" class="form-control" placeholder="Mobile Phone"
                                         id="CurrentSavePatientInfoRequest.RefContactNo"
                                         [(ngModel)]="CurrentSavePatientInfoRequest.RefContactNo"
                                         name="CurrentSavePatientInfoRequest.RefContactNo" pattern="[0-9]{10}"
                                         maxlength="10" minlength="1" mask="(000-000-0000)" #Telephone1="ngModel">
                                  <small class="form-text text-danger"
                                         *ngIf="(!Telephone1.valid)">(Provide Valid CellNo)</small>-->

                                  <input type="tel" class="form-control" placeholder="Mobile Phone"
                                         id="CurrentSavePatientInfoRequest.RefContactNo"
                                         [(ngModel)]="CurrentSavePatientInfoRequest.RefContactNo"
                                         mask="(000) 000-0000"
                                         name="CurrentSavePatientInfoRequest.RefContactNo" pattern="[0-9]{10}" #Telephone1="ngModel">
                                  <small class="form-text text-danger"
                                         *ngIf="(!Telephone1.valid)">(Provide Valid CellNo)</small>
                                </div>
                              </div>
                            </div>
                          </div>

                          <div class="row">
                            <div class="form-group col-md-12 col-xs-12 margin-bottom-5px">
                              <div class="row">

                                <div class="col-md-3 text-align-right">
                                  <label for="email address">Referral Institute</label>
                                </div>
                                <div class="col-md-3">
                                  <input type="text" class="form-control" placeholder="Institute"
                                         id="CurrentSavePatientInfoRequest.RefInstitute"
                                         [(ngModel)]="CurrentSavePatientInfoRequest.RefInstitute"
                                         name="CurrentSavePatientInfoRequest.RefInstitute" pattern="^[\sa-zA-Z0-9,._\-?]*$"
                                         maxlength="30" minlength="1">
                                </div>
                              </div>
                            </div>
                          </div>

                        </div>
                      </div>

                    </div>
                  </div>

                </div>
                <div class="card-footer">
                  <button type="button" class="btn btn-secondary btn-raised float-right margin-left-3px button-Schedule actions-btn-prime actions-btn-prime3 margin-left-auto font-size-13px" (click)="activeModal.close('Close click')">Close</button>
                  <button type="submit" class="btn actions-btn-prime float-right font-size-13px">Save</button>
                </div>
              </div>

            </form>



          </div>


          <div class="tab-pane" id="address">

            <form class="form" novalidate="" (ngSubmit)="Adress()" #f="ngForm">

              <div class="card card-height-417px">

                <div class="card-body margin-left-zero padding-left-0px padding-right-0px padding-bottom-0px">
                  <div class="row">
                    <div class="col-md-12 padding-l-0px">
                      <div class="card col-xl-12 col-lg-12 col-md-12 col-sm-12 my-profile-form padding-lr-0px">
                        <!--<div class="card-header wh-header card-header-bg padding-left-7px padding-top-6px margin-top-10">
                          Address
                          <button type="submit" [disabled]="!f.valid" *ngIf='!isRequesting' class="btn actions-btn-prime float-right">Save</button>

                        </div>-->
                        <div class="card-body card-body-general">
                          <div class="row">
                            <div class="form-group col-md-12 col-xs-12 margin-bottom-5px">
                              <div class="row">
                                <div class="col-md-3 text-align-right">
                                  <label for="diaplayName">Address Line1 </label>
                                </div>
                                <div class="col-md-7">
                                  <input type="text" class="form-control" placeholder="Address Line1"
                                         id="CurrentSavePatientInfoRequest.AddressLine1"
                                         [(ngModel)]="CurrentSavePatientInfoRequest.AddressLine1"
                                         name="CurrentSavePatientInfoRequest.AddressLine1" pattern="^[\sa-zA-Z0-9,._''\-?]*$" #AddressLine1="ngModel"
                                         maxlength="100" />
                                  <!--<small class="form-text text-danger"
          *ngIf="(!AddressLine1.valid && AddressLine1.errors.pattern)">(special characters are not allowed)</small>-->
                                </div>
                              </div>


                            </div>
                          </div>
                          <div class="row">
                            <div class="form-group col-md-12 col-xs-12 margin-bottom-5px">
                              <div class="row">
                                <div class="col-md-3 text-align-right">
                                  <label for="diaplayName">Address Line2 </label>
                                </div>
                                <div class="col-md-7">
                                  <input type="text" class="form-control" placeholder="Address Line2"
                                         id="CurrentSavePatientInfoRequest.AddressLine2"
                                         [(ngModel)]="CurrentSavePatientInfoRequest.AddressLine2"
                                         name="CurrentSavePatientInfoRequest.AddressLine2" pattern="^[\sa-zA-Z0-9,._\-?]*$" #AddressLine2="ngModel"
                                         maxlength="100" />
                                  <!--id="CurrentActorPersonalDetailInfoRequest.AddressLine2"
                 [(ngModel)]="CurrentActorPersonalDetailInfoRequest.AddressLine2"
                 name="CurrentActorPersonalDetailInfoRequest.AddressLine2" pattern="^[\sa-zA-Z0-9,._\-?]*$" #AddressLine2="ngModel"
                 maxlength="100" />
          <small class="form-text text-danger"
                 *ngIf="(!AddressLine2.valid && AddressLine2.errors.pattern)">(special characters are not allowed)</small>-->
                                </div>
                              </div>


                            </div>
                          </div>
                          <div class="row">
                            <div class="form-group col-md-12 col-xs-12 margin-bottom-5px">
                              <div class="row">
                                <div class="col-md-3 text-align-right">
                                  <label for="diaplayName">Country </label>
                                </div>
                                <div class="col-md-3">
                                  <CodeTypeValue CodeType="CNTR"
                                                 id="CurrentSavePatientInfoRequest.County"
                                                 [(ngModel)]="CurrentSavePatientInfoRequest.County"
                                                 name="CurrentSavePatientInfoRequest.County"
                                                 (keyChange)="Country($event)">
                                  </CodeTypeValue>
                                  
                                </div>
                              </div>


                            </div>
                          </div>
                          <div class="row">
                            <div class="form-group col-md-12 col-xs-12 margin-bottom-5px">
                              <div class="row">
                                <div class="col-md-3 text-align-right">
                                  <label for="diaplayName">State </label>
                                </div>
                                <div class="col-md-3" *ngIf="CountryName == 'INDIA'">
                                  <CodeTypeValue CodeType="State"
                                                 id="CurrentSavePatientInfoRequest.State"
                                                 [(ngModel)]="CurrentSavePatientInfoRequest.State"
                                                 name="CurrentSavePatientInfoRequest.State"></CodeTypeValue>
                                </div>
                                <div class="col-md-3" *ngIf="CountryName != 'INDIA'">
                                  <input type="text" class="form-control" placeholder="State"
                                         id="CurrentSavePatientInfoRequest.State"
                                         [(ngModel)]="CurrentSavePatientInfoRequest.State"
                                         name="CurrentSavePatientInfoRequest.State" pattern="^[\sa-zA-Z0-9,._\-?]*$" #State="ngModel"
                                         maxlength="100" />
                                </div>
                              </div>
                            </div>
                          </div>

                          <div class="row">
                            <div class="form-group col-md-12 col-xs-12 margin-bottom-5px">
                              <div class="row">
                                <div class="col-md-3 text-align-right">
                                  <label for="diaplayName">
                                    City
                                  </label>
                                </div>
                                <div class="col-md-3" *ngIf="CountryName == 'INDIA'">
                                  <CodeTypeValue CodeType="City"
                                                 id="CurrentSavePatientInfoRequest.City"
                                                 [(ngModel)]="CurrentSavePatientInfoRequest.City"
                                                 name="CurrentSavePatientInfoRequest.City"></CodeTypeValue>                                  
                                </div>
                                <div class="col-md-3" *ngIf="CountryName != 'INDIA'">
                                  <input type="text" class="form-control" placeholder="City"
                                         id="CurrentSavePatientInfoRequest.City"
                                         [(ngModel)]="CurrentSavePatientInfoRequest.City"
                                         name="CurrentSavePatientInfoRequest.City" pattern="^[\sa-zA-Z0-9,._\-?]*$" #City="ngModel"
                                         maxlength="100" />
                                </div>
                              </div>
                            </div>
                          </div>
                          <div class="row">
                            <div class="form-group col-md-12 col-xs-12 margin-bottom-5px">
                              <div class="row">
                                <div class="col-md-3 text-align-right">
                                  <label for="diaplayName">Zip Code</label>
                                </div>
                                <div class="col-md-3">
                                  <input type="text" class="form-control" placeholder="Zip Code"
                                         id="CurrentSavePatientInfoRequest.ZipCode"
                                         [(ngModel)]="CurrentSavePatientInfoRequest.ZipCode"
                                         name="CurrentSavePatientInfoRequest.ZipCode" #ZipCode="ngModel"
                                         maxlength="6" pattern="[0-9]{6}">
                                  <small class="form-text text-danger"
                                         *ngIf="(!ZipCode.valid && (ZipCode.dirty || ZipCode.touched) && ZipCode.errors.required )">(Field cannot be left blank)</small>
                                  <small class="form-text text-danger"
                                         *ngIf="(!ZipCode.valid && ZipCode.errors.pattern)">(only numbers are allowed)</small>
                                  <!--<input class="form-control" type="number" id="username" name="username" maxlength="6" >-->
                                </div>
                              </div>
                            </div>
                          </div>
                          <!--<div class="row">
    <div class="form-group col-md-12 col-xs-12 margin-bottom-5px">
      <div class="row">
        <div class="col-md-3 text-align-right">
          <label for="diaplayName">Zip </label>
        </div>
        <div class="col-md-3">
          <input type="text" class="form-control" id="CurrentActorPersonalDetailInfoRequest.Zip"
                 [(ngModel)]="CurrentActorPersonalDetailInfoRequest.Zip"
                 name="CurrentActorPersonalDetailInfoRequest.Zip" #Zip="ngModel" pattern="[0-9]{5}"
                 placeholder="Zip" maxlength="5" />
          <small class="form-text text-danger"
                 *ngIf="(!Zip.valid && Zip.errors.pattern)">(special characters are not allowed)</small>
        </div>
      </div>
    </div>
  </div>-->
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="card-footer">
                  <button type="button" class="btn btn-secondary btn-raised float-right margin-left-3px button-Schedule actions-btn-prime actions-btn-prime3 margin-left-auto font-size-13px" (click)="activeModal.close('Close click')">Close</button>
                  <button type="submit" class="btn actions-btn-prime float-right font-size-13px">Save</button>
                </div>
              </div>
            </form>
          </div>
          <div class="tab-pane" id="contact">
            <form class="form" novalidate="" (ngSubmit)="Contact()" #f="ngForm">
              <div class="card card-height-417px">
                <div class="card-body margin-left-zero padding-left-0px padding-right-0px padding-bottom-0px">
                  <div class="row">
                    <div class="col-md-12 padding-l-0px">
                      <div class="card col-xl-12 col-lg-12 col-md-12 col-sm-12 my-profile-form padding-lr-0px">
                        <!--<div class="card-header wh-header card-header-bg padding-left-7px padding-top-6px margin-top-10">
                          Contact
                          <button type="submit" [disabled]="!f.valid" *ngIf='!isRequesting' class="btn actions-btn-prime float-right">Save</button>
                        </div>-->
                        <div class="card-body card-body-general">
                          <div class="row">
                            <div class="form-group col-md-12 col-xs-12 margin-bottom-5px">
                              <div class="row">
                                <div class="col-md-3 text-align-right">
                                  <label for="diaplayName"><span>*</span> Mobile Phone </label>
                                </div>
                                <div class="col-md-3">
                                  <!--<input type="tel" class="form-control" placeholder="Mobile Phone"
                                         id="CurrentSavePatientInfoRequest.Telephone1"
                                         [(ngModel)]="CurrentSavePatientInfoRequest.Telephone1"
                                         mask="(000) 000-0000"
                                         name="CurrentSavePatientInfoRequest.Telephone1" pattern="[0-9]{10}" #phone1="ngModel" />
                                  <small class="form-text text-danger"
                                         *ngIf="(!phone1.valid)">(Provide Valid CellNo)</small>-->
                                  <input type="tel" class="form-control" placeholder="Mobile Phone"
                                         id="CurrentSavePatientInfoRequest.Telephone1"
                                         [(ngModel)]="CurrentSavePatientInfoRequest.Telephone1"
                                         name="CurrentSavePatientInfoRequest.Telephone1"
                                         maxlength="25" minlength="1" #phone1="ngModel">
                                </div>
                              </div>
                            </div>
                          </div>
                          <!--<div class="row">
                            <div class="form-group col-md-12 col-xs-12 margin-bottom-5px">
                              <div class="row">
                                <div class="col-md-3 text-align-right">
                                  <label for="diaplayName">Telephone </label>
                                </div>
                                <div class="col-md-3">
                                  <input type="tel" class="form-control" id="CurrentActorPersonalDetailInfoRequest.Telephone2"
                                         [(ngModel)]="CurrentActorPersonalDetailInfoRequest.Telephone2"
                                         mask="(000) 000-0000"
                                         name="CurrentActorPersonalDetailInfoRequest.Telephone2" pattern="[0-9]{10}" #Telephone2="ngModel"
                                         placeholder="Telephone" />
                                  <small class="form-text text-danger"
                                         *ngIf="(!Telephone2.valid)">(Provide Valid Phone No)</small>
                                </div>
                              </div>
                            </div>
                          </div>-->
                          <div class="row">
                            <div class="form-group col-md-12 col-xs-12 margin-bottom-5px">
                              <div class="row">
                                <div class="col-md-3 text-align-right">
                                  <label for="email address"> Email Address  </label>
                                </div>
                                <div class="col-md-4">
                                  <!--<input type="email" class="form-control" placeholder="Email"
                                         id="CurrentSavePatientInfoRequest.Email"
                                         [(ngModel)]="CurrentSavePatientInfoRequest.Email"
                                         name="CurrentSavePatientInfoRequest.Email" pattern="[A-Za-z0-9._%+-]+@[A-Za-z0-9.-]+\.[A-Za-z]{2,3}$" #Email="ngModel"
                                         maxlength="30">
                                  <small class="form-text text-danger"
                                         *ngIf="(!Email.valid && (Email.dirty || Email.touched)  && Email.errors.required)">(Provide Valid Email)</small>-->
                                  <input type="email" class="form-control" id="CurrentSavePatientInfoRequest.Email"
                                         [(ngModel)]="CurrentSavePatientInfoRequest.Email"
                                         name="CurrentSavePatientInfoRequest.Email"
                                         placeholder="Email" pattern="[A-Za-z0-9._%+-]+@[A-Za-z0-9.-]+\.[A-Za-z]{2,3}$"
                                         #Email="ngModel" maxlength="30" minlength="4">
                                  <small class="form-text text-danger"
                                         *ngIf="(!Email.valid && (Email.dirty || Email.touched)  && Email.errors.required)">(Provide Valid Email)</small>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="card-footer">
                  <button type="button" class="btn btn-secondary btn-raised float-right margin-left-3px button-Schedule actions-btn-prime actions-btn-prime3 margin-left-auto font-size-13px" (click)="activeModal.close('Close click')">Close</button>
                  <button type="submit" class="btn actions-btn-prime float-right font-size-13px" [disabled]="CurrentSavePatientInfoRequest.Telephone1==''">Save</button>
                </div>
              </div>
            </form>
          </div>
          <div class="tab-pane" id="spouse">
            <form class="form" novalidate="" (ngSubmit)="JoinSpouse()" #f="ngForm">
              <div class="card card-height-417px">
                <div class="card-body margin-left-zero padding-left-0px padding-right-0px padding-bottom-0px">
                  <div class="row">
                    <div class="col-md-12 padding-l-0px">
                      <div class="card col-xl-12 col-lg-12 col-md-12 col-sm-12 my-profile-form padding-lr-0px">
                        
                        <div class="card-body card-body-general">
                          <div class="row">
                            <div class="form-group col-md-12 col-xs-12 margin-bottom-5px">
                              <div class="row">
                                <div class="col-md-3 text-align-right">
                                  <label for="email address">Partner Name</label>
                                </div>                                
                                <div class="col-md-3">
                                  <!--<label class="font-size-14 margin-bottom-0px"*ngIf="SpouseNameO">{{SpouseName}}</label>-->
                                  <label class="font-size-14 margin-bottom-0px">{{PartnerName}}</label>
                                </div>
                                <div class="col-md-2">
                                  <button type="button"
                                          class="btn btn-secondary font-size-13px btn-raised button-Schedule action-button-prime-cycle actions-btn-prime3"
                                          (click)="SelectSpouse()"> <i class="fas fa-ellipsis-h"></i></button>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="card-footer">
                  <button type="button" class="btn btn-secondary btn-raised float-right margin-left-3px button-Schedule actions-btn-prime actions-btn-prime3 margin-left-auto font-size-13px" (click)="activeModal.close('Close click')">Close</button>
                  <button type="submit" class="btn actions-btn-prime float-right font-size-13px" [disabled]="CurrentSavePatientInfoRequest.Telephone1==''">Save</button>
                </div>
              </div>
            </form>
          </div>
        </div>
      </div>

    </div>
  </div>
</div>
